import { IconButton } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useState } from 'react';

interface PSCChecklistProps {
    imoNumber: string;
    port: string;
    classNumber: string;
    eta: string;
    vesselName: string;
    generateChecklistPdf: (imoNumber: string, port: string, classNumber: string, eta: string, vesselName: string) => Promise<void>;
}

const PSCChecklist = ({ imoNumber, port, classNumber, eta, vesselName, generateChecklistPdf }: PSCChecklistProps) => {
    const [loading, setLoading] = useState(false);

    const handleGeneratePdf = async () => {
        setLoading(true);
        await generateChecklistPdf(imoNumber, port, classNumber, eta, vesselName);
        setLoading(false);
    };

    return (
        <IconButton onClick={handleGeneratePdf} disabled={loading}>
            <ArrowDownwardIcon />
        </IconButton>
    );
};

export default PSCChecklist;
